/* eslint-disable linebreak-style */
'use client'

import {useEffect} from 'react'

const InteractiveModule = () => {
  useEffect(() => {
    if (window.LiveOverlay) {
      const liveOverlay = window.LiveOverlay

      liveOverlay.initialize({
        api: process.env.NEXT_PUBLIC_ITR_API,
        wss: process.env.NEXT_PUBLIC_ITR_WSS,
        iframeClass: 'live-iframe',
        payment: process.env.NEXT_PUBLIC_ITR_PAYMENT,
      })
    } else {
      console.error('LivePlayer is not defined')
    }
  }, [])
  return <></>
}

export default InteractiveModule
